import styled from 'styled-components';

export const Content = styled.div`
	width: 734px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 40px;
`;

export const Title = styled.div`
	font-weight: bold;
	font-size: 24px;
	line-height: 34px;
	text-align: center;
`;

export const Text = styled.div`
	max-width: 605px;
	margin: 32px auto;
	font-size: 18px;
	line-height: 24px;
`;

export const ButtonWrap = styled.div`
	display: flex;
	justify-content: center;

	a,
	a:visited,
	a:focus,
	a:active,
	a:hover {
		color: #fff;
		text-decoration: none;
	}
`;
